import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Thumbnail = styled.div`
  height: 200px;
  background-color: ${(props) => props.theme.home.cardLoaderBgColor};
  animation: flicker 2s ease-in-out 0s infinite;

  @keyframes flicker {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }
`;

const InfoLayout = styled.div`
  display: flex;
  height: 50px;
  gap: 10px;
`;

const Framework = styled.div`
  min-width: 40px;
  width: 40px;
  background-color: ${(props) => props.theme.home.cardLoaderBgColor};
  animation: flicker 1.5s ease-in-out 1s infinite;
`;

const NameBox = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Name = styled.div`
  flex: 1;
  background-color: ${(props) => props.theme.home.cardLoaderBgColor};
  animation: flicker 1.8s ease-in-out 0.4s infinite;
`;

const Date = styled.div`
  flex: 0.7;
  background-color: ${(props) => props.theme.home.cardLoaderBgColor};
  animation: flicker 1.8s ease-in-out 0.4s infinite;
`;

const BlurCard = () => {
  return (
    <Container>
      <Thumbnail />
      <InfoLayout>
        <Framework />
        <NameBox>
          <Name></Name>
          <Date></Date>
        </NameBox>
      </InfoLayout>
    </Container>
  );
};

const ProjectCardLoader = () => {
  return (
    <>
      <BlurCard />
      <BlurCard />
      <BlurCard />
    </>
  );
};

export default ProjectCardLoader;
